// extracted by mini-css-extract-plugin
export var avatar = "_r8-3";
export var avatarContainer = "_r8-2";
export var avatarSpacer = "_r8-5";
export var avatarSpacerContainer = "_r8-4";
export var avatarStackContainer = "_r8-1";
export var bubble = "_r8-0";
export var remainderBubble = "_r8-6";